"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crosshair = void 0;
exports.view = view;
var unit_1 = require("../../unit");
var mithril_1 = require("../mithril");
var theme_1 = require("../theme");
function view(dc, ctx) {
    if (!dc.isIkePhoto) {
        return null;
    }
    var size = ctx.size, center = ctx.center, gap = ctx.gap, classNames = ctx.classNames, scale = ctx.scale, distance = ctx.distance;
    var strokeWidth = scale * 2;
    var halfHeight = size.height / 2;
    var halfWidth = size.width / 2;
    var elements = [];
    // Left to right
    elements.push((0, mithril_1.m)('line', {
        className: classNames.outerLine,
        x1: center.x - halfWidth,
        y1: center.y,
        x2: center.x - gap,
        y2: center.y,
        'stroke-width': (strokeWidth * 2) + 'px',
        stroke: ctx.outerStroke
    }));
    elements.push((0, mithril_1.m)('line', {
        className: classNames.innerLine,
        x1: center.x - halfWidth,
        y1: center.y,
        x2: center.x - gap,
        y2: center.y,
        'stroke-width': strokeWidth + 'px',
        stroke: ctx.innerStroke
    }));
    // Right to left
    elements.push((0, mithril_1.m)('line', {
        className: classNames.outerLine,
        x1: center.x + gap,
        y1: center.y,
        x2: center.x + halfWidth,
        y2: center.y,
        'stroke-width': (strokeWidth * 2) + 'px',
        stroke: ctx.outerStroke
    }));
    elements.push((0, mithril_1.m)('line', {
        className: classNames.innerLine,
        x1: center.x + gap,
        y1: center.y,
        x2: center.x + halfWidth,
        y2: center.y,
        'stroke-width': strokeWidth + 'px',
        stroke: ctx.innerStroke
    }));
    // Top to bottom
    elements.push((0, mithril_1.m)('line', {
        className: classNames.outerLine,
        x1: center.x,
        y1: center.y - halfHeight,
        x2: center.x,
        y2: center.y - gap,
        'stroke-width': (strokeWidth * 2) + 'px',
        stroke: ctx.outerStroke
    }));
    elements.push((0, mithril_1.m)('line', {
        className: classNames.innerLine,
        x1: center.x,
        y1: center.y - halfHeight,
        x2: center.x,
        y2: center.y - gap,
        'stroke-width': strokeWidth + 'px',
        stroke: ctx.innerStroke
    }));
    // Bottom to top
    elements.push((0, mithril_1.m)('line', {
        className: classNames.outerLine,
        x1: center.x,
        y1: center.y + gap,
        x2: center.x,
        y2: center.y + halfHeight,
        'stroke-width': (strokeWidth * 2) + 'px',
        stroke: ctx.outerStroke
    }));
    elements.push((0, mithril_1.m)('line', {
        className: classNames.innerLine,
        x1: center.x,
        y1: center.y + gap,
        x2: center.x,
        y2: center.y + halfHeight,
        'stroke-width': strokeWidth + 'px',
        stroke: ctx.innerStroke
    }));
    if (!isNaN(distance)) {
        var distanceText = (0, mithril_1.m)('text', {
            className: classNames.distance,
            fill: theme_1.StyleConfig.FONT_COLOR,
            stroke: 'none',
            x: halfWidth / 2,
            y: theme_1.StyleConfig.FONT_SIZE,
            'text-anchor': 'middle',
            'font-size': theme_1.StyleConfig.FONT_SIZE,
            'alignment-baseline': 'middle',
            style: {
                'user-select': 'none',
                'pointer-events': 'none',
                'font-weight': 'bold'
            }
        }, unit_1.IkeUnit.display(distance, ctx.units));
        var distanceRect = (0, mithril_1.m)('rect', {
            x: 0,
            y: 0,
            width: halfWidth,
            stroke: 'none',
            height: 8 + theme_1.StyleConfig.FONT_SIZE,
            fill: theme_1.StyleConfig.LABEL.FILL,
            'fill-opacity': '0.75'
        });
        var offsetX = center.x - halfWidth / 2 * scale;
        var offsetY = center.y + halfHeight * 1.25 + gap;
        elements.push((0, mithril_1.m)('g', {
            transform: "translate(".concat(offsetX, ",").concat(offsetY, ")scale(").concat(scale, ")")
        }, [distanceRect, distanceText]));
    }
    return (0, mithril_1.m)('g', { className: 'c-Draw-crosshair' }, elements);
}
exports.Crosshair = { view: view };
//# sourceMappingURL=crosshair.js.map